const _navigationsCategory = {
  MARITIME_TRAFFIC_REGULATIONS_ROUTE: 1,
  PORT_TRAFFIC_REGULATIONS_ROUTE: 2,
  LIGHTHOUSE: 3,
  LIGHT_BUOY: 4,
  LIGHT_BEACON: 5,
  OTHER: 6,
}

export default {
  data() {
    return {
      navigationsCategory: _navigationsCategory,
    };
  },
  methods: {
    getNavigationsCategoryIds(){
      let ids = [];
      Object.keys(_navigationsCategory).forEach((key) => {
        ids.push(_navigationsCategory[key]);
      });
      return ids.map(item => String(item));
    }
  }
};
